import React, { useState, useEffect } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import moment from 'moment';

export default function ModalRule(props) {
  const rule = props.model;
  const [dataChanging, setDataChanging] = useState({
    // type: rule.type || '',
    // state: rule.state || '',
  });

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  return (
    <>
      <Modal
        title={`Nueva regla de cobertura`}
        model={ rule }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity='sale/reglas-cobertura'
        dataForce={{
          // base_bureau_id: dataChanging.base_bureau_id,
          // type: dataChanging.type,

        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="periodo"
          margin="normal"
          defaultValue={moment(rule.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <TextField
          label="Código de regla"
          name="code"
          type="text"
          margin="normal"
          fullWidth
          defaultValue={!!rule ? rule.code : ''}
          inputProps={{
            maxLength: 3,
            minLength: 1
          }}
          required
        />
        <TextField
          label="Nombre de la Cobertura"
          type="text"
          name="cobertura"
          margin="normal"
          fullWidth
          defaultValue={!!rule ? rule.cobertura : ''}
        />
      </Modal>
    </>
  );
}
